module.exports = __webpack_public_path__ + "media/images/category/feature/coj_b/coj_b-1-224cf35ffe19c765578d9ebe9ac962bf.jpg";